import { render, staticRenderFns } from "./talent_report.vue?vue&type=template&id=0987082e&scoped=true"
import script from "./talent_report.vue?vue&type=script&lang=js"
export * from "./talent_report.vue?vue&type=script&lang=js"
import style0 from "./talent_report.vue?vue&type=style&index=0&id=0987082e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987082e",
  null
  
)

export default component.exports